import React, { Component, RefObject } from 'react';
import Textbox from '../../atoms/Textbox';
import Checkbox from '../../atoms/Checkbox';
import { Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Dropdown from '../../atoms/Dropdown';
import { StoreInfo } from '../../../external/StoresApi';
import {
  allAgencyOnMngcstmIsFalse,
  getAgencyList,
  getBillcstmList,
  getFilteredAgencyList,
  getFilteredBillcstmList,
  getFilteredMngcstmList,
  getMngcstmList,
  setAgencyList,
  setMngcstmList,
  mngcstmListFormatCheckboxWhenAllAgencyIsFalse,
  mngcstmListFormatCheckboxWhenAllAgencyIsNotFalse,
  checkAllAgencyOnMngcstmIsFalse,
  checkAllMngcstmOnBillcstmIsFalse,
  setStatusMngcstmCheckbox,
  convertKeyMngcstmCd,
} from './functions';
import { AUTH_ROLE, getCompanyCfcDisplayName } from '../../../Common';
import { FilterItem } from '../../../redux/reducers/StoreFilterReducer';
export interface StoreSelectModalProps {
  postCd: string;
  stores: StoreInfo[];
  targetStores: string[];
  itemActive: FilterItem;
  errorMessageHeight: number;
  updateDraftStore: (itemActive: FilterItem) => void;
}

export interface booleanMap {
  [key: string]: boolean;
}

export interface checkedMap {
  [key: string]: boolean | undefined;
}

export interface AgencyInfo {
  agencyCd: string;
  longName: string;
  mngcstmCd: string;
}

export interface MngcstmInfo {
  agencyCd: string;
  mngcstmCd: string;
  longName: string;
  billcstmCd: string;
  isActive: boolean;
}

export interface BillcstmInfo {
  billcstmCd: string;
  billcstmLongNm: string;
  isActive: boolean;
}

export interface StoreSelectModalState {
  anchorEl: HTMLElement | null;
  searchValue: string;
  //画面に表示されている一次代理店一覧
  displayedOnBillcstmList: BillcstmInfo[];
  isBillcstmChecked: checkedMap;
  //画面に表示されている運営店一覧
  displayedOnMngcstmList: MngcstmInfo[];
  isMngcstmChecked: checkedMap;
  //画面に表示されている取次店一覧
  displayedOnAgencyList: AgencyInfo[];
  isStoreChecked: booleanMap;
  isBillcstmDisplay: boolean;
  isMngcstmDisplay: boolean;
}

export default class extends Component<StoreSelectModalProps, StoreSelectModalState> {
  private inputRef: RefObject<HTMLInputElement>;

  constructor(props: StoreSelectModalProps) {
    super(props);

    this.state = {
      anchorEl: null,
      searchValue: '',
      displayedOnBillcstmList: [],
      isBillcstmChecked: {},
      displayedOnMngcstmList: [],
      isMngcstmChecked: {},
      displayedOnAgencyList: [],
      isStoreChecked: {},
      isBillcstmDisplay: true,
      isMngcstmDisplay: true,
    };

    this.inputRef = React.createRef<HTMLInputElement>();
    this.changeTargetStoresOnBillcstm = this.changeTargetStoresOnBillcstm.bind(this);
    this.changeTargetStoresOnClickMngcstm = this.changeTargetStoresOnClickMngcstm.bind(this);
    this.changeTargetStoresOnClickAgency = this.changeTargetStoresOnClickAgency.bind(this);
    this.changeActiveBillcstm = this.changeActiveBillcstm.bind(this);
    this.changeActiveMngcstm = this.changeActiveMngcstm.bind(this);
    this.isIndeterminateFromMng = this.isIndeterminateFromMng.bind(this);
    this.isIndeterminateFromBill = this.isIndeterminateFromBill.bind(this);
  }

  /**
   * 運営店の一部選択状態を判定する
   */
  isIndeterminateFromMng(mngcstmCd: string): boolean {
    const { stores } = this.props;
    const { isMngcstmChecked, isStoreChecked } = this.state;

    //運営店チェックが入っていない
    if (isMngcstmChecked[mngcstmCd] === false) {
      return false;
    }

    //運営店配下の取次店のチェックが全て選択状態か?
    const allAgencyOnMngcstmIsTrue = getAgencyList(stores, mngcstmCd)
      .map((agency) => agency.agencyCd)
      .every((agencyCd) => isStoreChecked[agencyCd] === true);
    if (allAgencyOnMngcstmIsTrue) {
      return false;
    }

    //運営店配下の取次店のチェックが全て未選択状態か?
    return checkAllAgencyOnMngcstmIsFalse(stores, mngcstmCd, this.state);
  }

  /**
   * 一次代理店の一部選択状態を判定する
   */
  isIndeterminateFromBill(billcstmCd: string): boolean {
    const { stores } = this.props;
    const { isBillcstmChecked, isStoreChecked } = this.state;

    //一次代理店チェックが入っていない
    if (isBillcstmChecked[billcstmCd] === false) {
      return false;
    }

    //一次代理店配下の各運営店の各取次店のチェックが全て選択状態か?
    const allMngcstmOnBillcstmIsTrue = getMngcstmList(stores, billcstmCd)
      .map((mngcstmInfo) => mngcstmInfo.mngcstmCd)
      .every((mngcstmCd) => {
        //運営店配下の取次店のチェックが全て選択状態か?
        const allAgencyOnMngcstmIsTrue = getAgencyList(stores, mngcstmCd)
          .map((agency) => agency.agencyCd)
          .every((agencyCd) => isStoreChecked[agencyCd] === true);
        if (allAgencyOnMngcstmIsTrue) {
          return true;
        }
        return false;
      });
    if (allMngcstmOnBillcstmIsTrue) {
      return false;
    }

    //一次代理店配下の各運営店の各取次店のチェックが全て未選択状態か?
    return checkAllMngcstmOnBillcstmIsFalse(stores, billcstmCd, this.state);
  }

  /**
   * チェックボックスの状態が変わり、検索対象店舗の数を再計算して
   * propsのtargetStoresをupdateする
   */
  changeTargetStoresOnBillcstm(billcstmCd: string) {
    const { stores } = this.props;
    const newState: StoreSelectModalState = { ...this.state };
    const { isBillcstmChecked, isMngcstmChecked, isStoreChecked } = newState;
    const checked = isBillcstmChecked[billcstmCd];
    if (checked === true) {
      isBillcstmChecked[billcstmCd] = false;
    } else {
      isBillcstmChecked[billcstmCd] = true;
    }

    //一次代理店配下の運営店を抽出
    getMngcstmList(stores, billcstmCd).forEach((mngcstmInfo) => {
      const mngcstmCd = mngcstmInfo.mngcstmCd;
      //isMngcstmCheckedの中の全ての運営店のチェックを変更
      isMngcstmChecked[mngcstmCd] = isBillcstmChecked[billcstmCd];

      //isStoreCheckedの中の全ての運営店のチェックを変更
      isStoreChecked[mngcstmInfo.agencyCd] = isBillcstmChecked[billcstmCd] === true;

      //運営店配下の取次店を抽出
      getAgencyList(stores, mngcstmCd)
        //全ての取次店のチェックを変更
        .forEach((agencyInfo) => (isStoreChecked[agencyInfo.agencyCd] = isMngcstmChecked[mngcstmCd] === true));
    });

    this.props.updateDraftStore({
      ...this.props.itemActive,
      ordcstmCdList: stores
        .filter((store) => store.agencyCd !== store.mngcstmCd)
        .map((storeInfo) => storeInfo.agencyCd)
        .filter((agencyCd) => isStoreChecked[agencyCd]),
    });

    this.setState({
      isBillcstmChecked: newState.isBillcstmChecked,
      isMngcstmChecked: isMngcstmChecked,
      isStoreChecked: isStoreChecked,
    });
  }

  changeTargetStoresOnClickMngcstm(mngcstmCd: string, agencyCdInMngcstmCd: string) {
    const { stores } = this.props;
    const newState: StoreSelectModalState = { ...this.state };
    const { isMngcstmChecked, isBillcstmChecked, isStoreChecked } = newState;
    const checked = isMngcstmChecked[mngcstmCd];
    if (checked === true) {
      isMngcstmChecked[mngcstmCd] = false;
    } else {
      isMngcstmChecked[mngcstmCd] = true;
    }

    //運営店配下の取次店を全て更新
    getAgencyList(stores, mngcstmCd).forEach((agency) => {
      //isStoreCheckedの中の取次店のチェックを変更
      isStoreChecked[agency.agencyCd] = isMngcstmChecked[mngcstmCd] === true;
    });

    //運営店そのものの取次店も更新
    if (typeof isStoreChecked[agencyCdInMngcstmCd] !== 'undefined') {
      isStoreChecked[agencyCdInMngcstmCd] = isMngcstmChecked[mngcstmCd] === true;
    }

    //全ての運営店に紐づく取次店が全てチェックfalseなら、一次代理店もfalse
    const mngInfo = stores.find((store) => store.agencyCd === agencyCdInMngcstmCd);
    let billcstmCd: string;
    if (mngInfo && mngInfo.billcstmCd) {
      billcstmCd = mngInfo.billcstmCd;
    } else {
      //.others
      billcstmCd = agencyCdInMngcstmCd.split('.')[0];
    }
    if (typeof isBillcstmChecked[billcstmCd] !== 'undefined') {
      //一次代理店配下の運営店のチェックが全て未選択状態か?
      const allMngcstmOnBillcstmIsFalse = getMngcstmList(stores, billcstmCd)
        .map((mngcstmInfo) => mngcstmInfo.mngcstmCd)
        .every((mngcstmCd) => isMngcstmChecked[mngcstmCd] === false);

      if (allMngcstmOnBillcstmIsFalse) {
        isBillcstmChecked[billcstmCd] = false;
      } else {
        isBillcstmChecked[billcstmCd] = true;
      }
    }

    this.props.updateDraftStore({
      ...this.props.itemActive,
      ordcstmCdList: stores
        .filter((store) => store.agencyCd !== store.mngcstmCd)
        .map((storeInfo) => storeInfo.agencyCd)
        .filter((agencyCd) => isStoreChecked[agencyCd]),
    });

    this.setState({
      isBillcstmChecked: newState.isBillcstmChecked,
      isMngcstmChecked: newState.isMngcstmChecked,
      isStoreChecked: newState.isStoreChecked,
    });
  }

  changeTargetStoresOnClickAgency(agencyCd: string, mngcstmCd: string | undefined, billcstmCdParam: string | undefined = '') {
    const { stores } = this.props;
    const newState: StoreSelectModalState = { ...this.state };
    const { isStoreChecked } = newState;
    const { isMngcstmChecked, isBillcstmChecked } = newState;

    //取次店の状態の更新
    isStoreChecked[agencyCd] = !isStoreChecked[agencyCd];

    //全ての運営店に紐づく取次店が全てチェックfalseなら、運営店もfalse
    const targetAgencyCdInMngcstm = stores.find((store) => store.mngcstmCd === mngcstmCd && store.mngcstmCd === store.agencyCd);

    if (mngcstmCd) {
      const mngcstmCdConverted = convertKeyMngcstmCd(mngcstmCd, billcstmCdParam);
      //運営店配下の取次店のチェックが全て未選択状態か?
      const allAgencyOnMngcstmIsFalse = getAgencyList(stores, mngcstmCdConverted)
        .map((agency) => agency.agencyCd)
        .every((agencyCd) => {
          const aaa = isStoreChecked[agencyCd];

          return aaa === false;
        });

      if (allAgencyOnMngcstmIsFalse) {
        isMngcstmChecked[mngcstmCdConverted] = false;

        //isStoreCheckedの中の運営店のチェックを変更
        if (targetAgencyCdInMngcstm) {
          isStoreChecked[targetAgencyCdInMngcstm.agencyCd] = false;
        }
      } else {
        isMngcstmChecked[mngcstmCdConverted] = true;

        //isStoreCheckedの中の運営店のチェックを変更
        if (targetAgencyCdInMngcstm) {
          isStoreChecked[targetAgencyCdInMngcstm.agencyCd] = true;
        }
      }
    }

    //一次代理店に紐づく全ての運営店が全てチェックfalseなら、一次代理店もfalse
    const mngInfo = stores.find((store) => store.agencyCd === agencyCd);
    let billcstmCd: string;
    if (mngInfo && mngInfo.billcstmCd) {
      billcstmCd = mngInfo.billcstmCd;
    } else {
      //.others
      billcstmCd = agencyCd.split('.')[0];
    }

    //一次代理店配下の運営店のチェックが全て未選択状態か?
    const allMngcstmOnBillcstmIsFalse = getMngcstmList(stores, billcstmCd)
      .map((mngcstmInfo) => mngcstmInfo.mngcstmCd)
      .every((mngcstmCd) => isMngcstmChecked[mngcstmCd] === false);
    if (allMngcstmOnBillcstmIsFalse) {
      isBillcstmChecked[billcstmCd] = false;
    } else {
      isBillcstmChecked[billcstmCd] = true;
    }

    this.props.updateDraftStore({
      ...this.props.itemActive,
      ordcstmCdList: stores
        .filter((store) => store.agencyCd !== store.mngcstmCd)
        .map((storeInfo) => storeInfo.agencyCd)
        .filter((agencyCd) => isStoreChecked[agencyCd]),
    });

    this.setState({
      isBillcstmChecked: newState.isBillcstmChecked,
      isMngcstmChecked: newState.isMngcstmChecked,
      isStoreChecked: isStoreChecked,
    });
  }

  /**
   * 画面に表示されている一次代理店配下の店舗情報を、
   * クリックされた一次代理店配下の情報に更新する
   * @param activeBillcstmCd
   */
  changeActiveBillcstm(activeBillcstmCd: string) {
    const newState: StoreSelectModalState = { ...this.state };
    const { displayedOnBillcstmList: billcstmList } = newState;
    if (
      (billcstmList.filter((obj) => obj.isActive).length ? billcstmList.filter((obj) => obj.isActive)[0].billcstmCd : '') !==
      activeBillcstmCd
    ) {
      billcstmList.forEach((obj) => (obj.isActive = obj.billcstmCd === activeBillcstmCd));
      setMngcstmList(newState, this.props.stores, activeBillcstmCd);
      this.setState({
        displayedOnBillcstmList: billcstmList,
        displayedOnMngcstmList: newState.displayedOnMngcstmList,
        displayedOnAgencyList: newState.displayedOnAgencyList,
      });
    }
  }

  /**
   * 画面に表示されている運営店配下の店舗情報を、
   * クリックされた運営店配下の情報に更新する
   * @param activeMngcstmCd
   */
  changeActiveMngcstm(activeMngcstmCd: string) {
    const newState: StoreSelectModalState = { ...this.state };
    const { displayedOnMngcstmList: mngcstmList } = newState;
    if (
      (mngcstmList.filter((obj) => obj.isActive).length ? mngcstmList.filter((obj) => obj.isActive)[0].mngcstmCd : '') !== activeMngcstmCd
    ) {
      mngcstmList.forEach((obj) => {
        obj.isActive = obj.mngcstmCd === activeMngcstmCd;
      });
      mngcstmList
        .filter((obj) => obj.isActive)
        .forEach((mngcstmInfo) => {
          setAgencyList(
            newState,
            this.props.stores.filter((storeInfo) => !mngcstmInfo.billcstmCd || storeInfo.billcstmCd === mngcstmInfo.billcstmCd),
            activeMngcstmCd,
          );
        });
      this.setState({
        displayedOnMngcstmList: mngcstmList,
        displayedOnAgencyList: newState.displayedOnAgencyList,
      });
    }
  }

  /**
   * propsの店舗リストをモーダル用のStateに展開する
   * @param prevProps 更新前のprops
   */
  componentDidUpdate(prevProps: StoreSelectModalProps) {
    //STEP1 画面表示する店舗の抽出
    /**
     * 新しいフィルタが追加されるたびに、[新規フィルタ] ボタンをクリックすると、新しいフィールドに値 NEW_FILTER_ID が filterID に渡されます。
     * したがって、新しいフィルターを追加するたびにフィルターを区別するために、filterUuid フィールドを追加する必要があります。
     */
    if (
      this.props.itemActive.filterID !== prevProps.itemActive.filterID ||
      this.props.itemActive.filterUuid !== prevProps.itemActive.filterUuid
    ) {
      this.renderWithActiveFilterStore();
    }
  }

  componentDidMount(): void {
    this.renderWithActiveFilterStore();
  }

  renderWithActiveFilterStore = () => {
    const newState: StoreSelectModalState = { ...this.state };
    const { stores, targetStores, postCd } = this.props;
    if (AUTH_ROLE[postCd]) {
      const billcstmList: BillcstmInfo[] = getBillcstmList(stores);
      if (billcstmList.length && billcstmList.filter((obj) => obj.isActive).length === 0) {
        billcstmList[0].isActive = true;
      }
      newState.displayedOnBillcstmList = billcstmList;
      const activeBillcstmCd = billcstmList.filter((obj) => obj.isActive).length
        ? billcstmList.filter((obj) => obj.isActive)[0].billcstmCd
        : billcstmList.length
        ? billcstmList[0].billcstmCd
        : '';
      const activeBillcstmStores = stores.filter((storeInfo) => !activeBillcstmCd || storeInfo.billcstmCd === activeBillcstmCd);
      const mngcstmList = getMngcstmList(stores, activeBillcstmCd);
      if (mngcstmList.length && mngcstmList.filter((obj) => obj.isActive).length === 0) {
        mngcstmList[0].isActive = true;
      }
      newState.displayedOnMngcstmList = mngcstmList;
      const activeMngcstmCd = mngcstmList.filter((obj) => obj.isActive).length
        ? mngcstmList.filter((obj) => obj.isActive)[0].mngcstmCd
        : mngcstmList.length
        ? mngcstmList[0].mngcstmCd
        : '';
      newState.displayedOnAgencyList = getAgencyList(activeBillcstmStores, activeMngcstmCd);

      //STEP2 チェックボックスの状態の取得
      //一旦全部未選択状態にする
      const bill = new Set<string>();
      const mng = new Set<string>();
      const agency = new Set<string>();
      getBillcstmList(stores).forEach((billInfo) => {
        bill.add(billInfo.billcstmCd);
        getMngcstmList(stores, billInfo.billcstmCd).forEach((mngInfo) => {
          mng.add(mngInfo.mngcstmCd);
          if (!mngInfo.agencyCd.match(/.others/)) {
            agency.add(mngInfo.agencyCd);
          }
          getAgencyList(stores, mngInfo.mngcstmCd).forEach((agencyInfo) => {
            agency.add(agencyInfo.agencyCd);
          });
        });
      });

      Array.from(bill).forEach((billcstmCd) => {
        newState.isBillcstmChecked[billcstmCd] = false;
      });
      Array.from(mng).forEach((mngcstmCd) => {
        newState.isMngcstmChecked[mngcstmCd] = false;
      });
      Array.from(agency).forEach((agencyCd) => {
        newState.isStoreChecked[agencyCd] = false;
      });

      //運営店と取次店の更新
      //targetStoresの中に含まれている店舗であればチェック状態にする
      targetStores.forEach((target) => {
        const checkTargetStore = stores.find((storeInfo) => target === storeInfo.agencyCd);
        const isMngcstmDisplay = newState.isMngcstmDisplay;

        if (checkTargetStore) {
          // 取次店
          newState.isStoreChecked[checkTargetStore.agencyCd] = true;

          // 運営店
          // targetStoresの一次代理店コード配下の運営店リストを取得する
          // マッピングできる運営店コードが存在する場合、対象運営店にチェックする
          // マッピングできる運営店コードが存在しない場合、「その他」にチェックする
          setStatusMngcstmCheckbox(newState, mngcstmList, checkTargetStore, isMngcstmDisplay, stores);
        }
      });

      //運営店配下の取次店のチェックが全て選択状態か?
      stores
        .filter((target) => {
          //運営店のみを抽出
          return target.agencyCd.substr(0, target.agencyCd.length - 1) === target.mngcstmCd;
        })
        .forEach((mngTarget) => {
          if (mngTarget.mngcstmCd) {
            //取次店としての運営店を特定
            allAgencyOnMngcstmIsFalse(stores, mngTarget.mngcstmCd, newState);
          }
        });

      //一次代理店とotherのチェック処理
      Array.from(bill).forEach((billcstmCd) => {
        getMngcstmList(stores, billcstmCd)
          .filter((mngInfo) => getAgencyList(stores, mngInfo.mngcstmCd).length !== 0)
          .forEach((mngInfo) => {
            //運営店舗に紐づく取次店が全てチェックfalseなら運営点もfalse
            const allAgencyOnMngIsTrue = getAgencyList(stores, mngInfo.mngcstmCd).every(
              (agency) => newState.isStoreChecked[agency.agencyCd] === true,
            );
            if (allAgencyOnMngIsTrue) {
              newState.isMngcstmChecked[mngInfo.mngcstmCd] = true;
            } else {
              const allAgencyOnMngIsFalse = getAgencyList(stores, mngInfo.mngcstmCd).every(
                (agency) => newState.isStoreChecked[agency.agencyCd] === false,
              );
              if (allAgencyOnMngIsFalse) {
                newState.isMngcstmChecked[mngInfo.mngcstmCd] = false;
              }
            }
          });

        //一次代理店紐づく各運営店の各取次店が全てチェックfalseなら一次代理店もfalse
        const allAgencyOnBillcstmIsFalse = getMngcstmList(stores, billcstmCd)
          .filter((mngInfo) => getAgencyList(stores, mngInfo.mngcstmCd).length !== 0)
          .every((mngInfo) => {
            //運営店配下の取次店のチェックが全て未選択状態か?
            const allAgencyOnMngcstmIsFalse = getAgencyList(stores, mngInfo.mngcstmCd)
              .map((agency) => agency.agencyCd)
              .every((agencyCd) => newState.isStoreChecked[agencyCd] === false);
            if (allAgencyOnMngcstmIsFalse) {
              //everyの検証結果として全てfalseは正しい
              return true;
            } else {
              return false;
            }
          });

        //全て未選択なので一次代理店はfalse
        if (allAgencyOnBillcstmIsFalse) {
          mngcstmListFormatCheckboxWhenAllAgencyIsFalse(newState, stores, billcstmCd);
        } else {
          mngcstmListFormatCheckboxWhenAllAgencyIsNotFalse(newState, stores, billcstmCd);
        }
      });

      newState.isBillcstmDisplay = AUTH_ROLE[postCd].isBillcstmDisplay;
      newState.isMngcstmDisplay = AUTH_ROLE[postCd].isMngcstmDisplay;
    } else {
      //役職なし

      const agencyList: AgencyInfo[] = [];
      stores.forEach((storeInfo: StoreInfo) => {
        agencyList.push({
          agencyCd: storeInfo.agencyCd,
          longName: getCompanyCfcDisplayName(String(storeInfo.companyCfc), storeInfo.longName),
          mngcstmCd: '',
        });
      });
      newState.displayedOnAgencyList = agencyList;

      agencyList.forEach((agency) => {
        newState.isStoreChecked[agency.agencyCd] = false;
      });

      //取次店の更新
      //targetStoresの中に含まれている店舗であればチェック状態にする
      targetStores.forEach((target) => {
        const checkTargetStore = stores.find((storeInfo) => target === storeInfo.agencyCd);
        if (checkTargetStore) {
          //取次店
          newState.isStoreChecked[checkTargetStore.agencyCd] = true;
        }
      });

      newState.isBillcstmDisplay = false;
      newState.isMngcstmDisplay = false;
    }

    //STEP3 全選択/全解除状態の更新

    this.setState({
      displayedOnBillcstmList: newState.displayedOnBillcstmList,
      isBillcstmChecked: newState.isBillcstmChecked,
      displayedOnMngcstmList: newState.displayedOnMngcstmList,
      isMngcstmChecked: newState.isMngcstmChecked,
      displayedOnAgencyList: newState.displayedOnAgencyList,
      isStoreChecked: newState.isStoreChecked,
      isBillcstmDisplay: newState.isBillcstmDisplay,
      isMngcstmDisplay: newState.isMngcstmDisplay,
    });
  };

  // 検索結果ドロップダウン
  renderSuggestion() {
    const { stores } = this.props;

    return (
      <div className='' style={{ width: 720, maxWidth: '100%' }}>
        <Textbox
          data-testid-e2e='filterStoreSelectModal-searchTextBox'
          data-testid='filterStoreSearchTextBox'
          inputRef={this.inputRef}
          leftIcon='search'
          wrapperClass='filter-modal__textbox u-w-full'
          value={this.state.searchValue}
          placeholder='店舗名で検索'
          onChange={(e) => this.setState({ searchValue: e.target.value })}
        />
        {/* 検索結果リスト */}
        <ul className='list'>
          {this.state.isBillcstmDisplay && (
            <li
              data-testid='filterStoreSearchBillcstmTitle'
              data-testid-e2e='filterStoreSelectModal-searchBillcstmTitle'
              className='filter-modal__header-title'>
              一次代理店 ({getFilteredBillcstmList(stores, this.state.searchValue).length}
              件)
            </li>
          )}
          {this.state.isBillcstmDisplay &&
            getFilteredBillcstmList(stores, this.state.searchValue) &&
            getFilteredBillcstmList(stores, this.state.searchValue).map((billcstmInfo) => (
              <li
                key={billcstmInfo.billcstmCd}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchBillcstmResult'
                data-testid-e2e='filterStoreSelectModal-searchBillcstmResult'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  onChange={() => {
                    this.changeTargetStoresOnBillcstm(billcstmInfo.billcstmCd);
                  }}
                  checked={this.state.isBillcstmChecked[billcstmInfo.billcstmCd]}
                  isIndeterminate={this.isIndeterminateFromBill(billcstmInfo.billcstmCd)}
                  value={billcstmInfo.billcstmCd}
                />
                <Link
                  to='#'
                  onClick={() => {
                    this.changeTargetStoresOnBillcstm(billcstmInfo.billcstmCd);
                  }}>
                  {billcstmInfo.billcstmLongNm}
                </Link>
              </li>
            ))}
          {this.state.isMngcstmDisplay && (
            <li
              data-testid='filterStoreSearchMngcstmTitle'
              data-testid-e2e='filterStoreStoreSelectModal-searchMngcstmTitle'
              className='filter-modal__header-title'>
              運営店 ({getFilteredMngcstmList(stores, this.state.searchValue).length}件)
            </li>
          )}
          {this.state.isMngcstmDisplay &&
            getFilteredMngcstmList(stores, this.state.searchValue) &&
            getFilteredMngcstmList(stores, this.state.searchValue).map((storeInfo) => (
              <li
                key={storeInfo.agencyCd}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchMngcstmResult'
                data-testid-e2e='filterStoreStoreSelectModal-searchMngcstmResult'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  onChange={() => {
                    this.changeTargetStoresOnClickMngcstm(storeInfo.agencyCd, storeInfo.agencyCd);
                  }}
                  checked={this.state.isMngcstmChecked[storeInfo.agencyCd]}
                  isIndeterminate={this.isIndeterminateFromMng(storeInfo.agencyCd)}
                  value={storeInfo.agencyCd}
                />
                <Link
                  to='#'
                  onClick={() => {
                    this.changeTargetStoresOnClickMngcstm(storeInfo.agencyCd, storeInfo.agencyCd);
                  }}>
                  {storeInfo.longName}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoreSearchAgencyStoreTitle'
            data-testid-e2e='filterStoreStoreSelectModal-searchAgencyStoreTitle'
            className='filter-modal__header-title'>
            取次店 ({getFilteredAgencyList(stores, this.state.searchValue).length}件)
          </li>
          {getFilteredAgencyList(stores, this.state.searchValue) &&
            getFilteredAgencyList(stores, this.state.searchValue).map((storeInfo) => (
              <li
                key={storeInfo.agencyCd}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchAgencyStoreResult'
                data-testid-e2e='filterStoreSelectModal-searchAgencyStoreResult'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  onChange={() => {
                    this.changeTargetStoresOnClickAgency(storeInfo.agencyCd, storeInfo.mngcstmCd, storeInfo.billcstmCd);
                  }}
                  checked={this.state.isStoreChecked[storeInfo.agencyCd]}
                  value={storeInfo.agencyCd}
                />
                <Link
                  to='#'
                  onClick={() => {
                    this.changeTargetStoresOnClickAgency(storeInfo.agencyCd, storeInfo.mngcstmCd, storeInfo.billcstmCd);
                  }}>
                  {getCompanyCfcDisplayName(String(storeInfo.companyCfc), storeInfo.longName)}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    );
  }

  onCloseWithEscapeKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (e.key === 'Escape') {
      this.setState({ anchorEl: null });
    }
  }

  render() {
    const { anchorEl, searchValue } = this.state;
    const { errorMessageHeight } = this.props;

    return (
      <>
        <div style={{ position: 'relative', borderTop: '1px solid rgb(227, 223, 223)' }}>
          <Dropdown
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            popover={this.renderSuggestion()}
            onKeyDown={(e) => this.onCloseWithEscapeKeyDown(e)}
            onEnter={() => {
              this.inputRef.current?.focus();
            }}
            onClose={() => this.setState({ anchorEl: null })}
            onBackdropClick={() => this.setState({ anchorEl: null })}
            transitionDuration={0}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}>
            <Textbox
              readOnly
              leftIcon='search'
              wrapperClass='filter-modal__textbox u-w-full'
              value={searchValue}
              placeholder='店舗名で検索'
              onClick={(e) => {
                this.setState({ anchorEl: e.currentTarget });
              }}
              data-testid-e2e='storeSelectModal-openSearchTextBox'
              data-testid='openSearchTextBox'
            />
          </Dropdown>
        </div>
        <div
          className='filter-modal__drilldown'
          style={{
            width: '100%',
            maxHeight: `calc(100vh - 285px - ${errorMessageHeight}px)`,
          }}>
          {/* 1階層目 */}
          {this.state.isBillcstmDisplay && (
            <div className='filter-modal__drilldown-item' data-testid='filter-store-billcstm-content'>
              <div
                data-testid='filter-store-billcstm-head-title'
                data-testid-e2e='filterStoreSelectModal-billcstmTitle'
                className='filter-modal__header-title'>
                一次代理店 ({this.state.displayedOnBillcstmList.length}件)
              </div>
              <div className='filter-modal__scroll-area'>
                <ul className='list'>
                  {this.state.displayedOnBillcstmList &&
                    this.state.displayedOnBillcstmList.map((billcstmInfo) => (
                      <li
                        key={billcstmInfo.billcstmCd}
                        className={`list__item-link ${
                          billcstmInfo.isActive && 'list__item-link--active'
                        } list__item-link--has-right-icon list__item-link--has-left-icon`}
                        data-testid-e2e='filterStoreSelectModal-billcstmList'
                        data-testid='filter-store-billcstm-store-list'>
                        <Checkbox
                          className='list__left-checkbox'
                          name='example-checkbox'
                          onChange={(e) => {
                            this.changeTargetStoresOnBillcstm(billcstmInfo.billcstmCd);
                          }}
                          checked={this.state.isBillcstmChecked[billcstmInfo.billcstmCd]}
                          isIndeterminate={this.isIndeterminateFromBill(billcstmInfo.billcstmCd)}
                          value={billcstmInfo.billcstmCd}
                        />
                        <Link
                          to='#'
                          onClick={(e) => {
                            this.changeActiveBillcstm(billcstmInfo.billcstmCd);
                          }}>
                          {billcstmInfo.billcstmLongNm}
                        </Link>
                        <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          )}
          {/* 2階層目 */}
          {this.state.isMngcstmDisplay && (
            <div className='filter-modal__drilldown-item' data-testid='filter-store-mngcstm-content'>
              <div
                data-testid='filter-store-mngcstm-head-title'
                data-testid-e2e='filterStoreSelectModal-mngcstmTitle'
                className='filter-modal__header-title'>
                運営店 ({this.state.displayedOnMngcstmList.length}件)
              </div>
              <div className='filter-modal__scroll-area'>
                <ul className='list'>
                  {this.state.displayedOnMngcstmList &&
                    this.state.displayedOnMngcstmList.map((mngcstmInfo) => (
                      <li
                        key={mngcstmInfo.mngcstmCd}
                        className={`list__item-link ${
                          mngcstmInfo.isActive && 'list__item-link--active'
                        } list__item-link--has-right-icon list__item-link--has-left-icon`}
                        data-testid-e2e='filterStoreSelectModal-mngcstmList'
                        data-testid='filter-store-mngcstm-store-list'>
                        <Checkbox
                          className='list__left-checkbox'
                          name='example-checkbox'
                          onChange={(e) => {
                            this.changeTargetStoresOnClickMngcstm(mngcstmInfo.mngcstmCd, mngcstmInfo.agencyCd);
                          }}
                          checked={this.state.isMngcstmChecked[mngcstmInfo.mngcstmCd]}
                          isIndeterminate={this.isIndeterminateFromMng(mngcstmInfo.mngcstmCd)}
                          value={mngcstmInfo.mngcstmCd}
                        />
                        <Link
                          to='#'
                          onClick={() => {
                            this.changeActiveMngcstm(mngcstmInfo.mngcstmCd);
                          }}>
                          {mngcstmInfo.longName}
                        </Link>
                        <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          )}
          {/* 3階層目(最下層) */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-agency-content'>
            <div
              data-testid='filter-store-agency-head-title'
              data-testid-e2e='filterStoreSelectModal-agencyStoreTitle'
              className='filter-modal__header-title'>
              取次店 ({this.state.displayedOnAgencyList.length}件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAgencyList &&
                  this.state.displayedOnAgencyList.map((agencyInfo) => (
                    <li
                      key={agencyInfo.agencyCd}
                      className='list__item-link list__item-link--has-left-icon'
                      data-testid-e2e='filterStoreSelectModal-agencyList'
                      data-testid='filter-store-agency-store-list'>
                      <Checkbox
                        className='list__left-checkbox u-pointer-events-none'
                        name='example-checkbox-agency'
                        onChange={(e) => {
                          this.changeTargetStoresOnClickAgency(agencyInfo.agencyCd, agencyInfo.mngcstmCd);
                        }}
                        checked={this.state.isStoreChecked[agencyInfo.agencyCd]}
                        isIndeterminate={false}
                        value={agencyInfo.agencyCd}
                      />
                      <Link
                        to='#'
                        onClick={() => {
                          this.changeTargetStoresOnClickAgency(agencyInfo.agencyCd, agencyInfo.mngcstmCd);
                        }}>
                        {agencyInfo.longName}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
